import type { Row } from '../lib/row';

/**
 * Крупный процент на мелкой прибыли врёт, когда объём срезал стакан или лимит
 * конторы. Свой банк и свой баланс человек задал сам — это не «денег нет».
 */
export function moneyLie(row: Pick<Row, 'roiPct' | 'profit' | 'cappedBy'>): boolean {
  if (!(row.roiPct > 6) || !(row.profit < 300)) return false;
  return row.cappedBy === 'стакан' || row.cappedBy === 'лимит';
}
